<template>
  <div class="bottom-wa">
    <div class="bottom-t">
      <div class="zi">推荐使用Chrome浏览器访问系统@Copyright:2019-2023</div>
      <div class="jinggon">
        <span class="zi"></span>
      </div>
      <div class="jinggon gjy">
        <img src="" class="img" />
        <span class="zi">版权所有：武汉高教云网络技术有限公司    鄂ICP备2022005298号</span>
      </div>
      <!-- <div class="jinggon">
        <img :src="require('../../../../public/static/images/jingying.png')" class="img" alt="">
        <span class="zi">xx公司</span>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  filters: {},
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    toGongan() {
      window.open()
    },
    toip() {
      window.open()
    },
    /** 切换 */
    change(route) {
      this.$router.push({ name: route.children[0].name })
    },
    businessQualification() {
      this.$router.push({ name: 'businessQualification' })
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/Bottom.mobile';
}
@media screen and (min-width: 769px) {
  @import '../styles/Bottom.pc';
}

@media screen and (max-width: 600px) {  
  .gjy{
    display: none !important;
  }
} 
</style>
